"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var DropDown_1 = __importDefault(require("../../../../common/DropDown/DropDown"));
var reportType_1 = require("../data/reportType");
function ReportType(props) {
    var _a = (0, react_1.useState)([]), type = _a[0], setType = _a[1];
    (0, react_1.useEffect)(function () {
        if (props.isGroup) {
            var tmp = reportType_1.reportType.filter(function (l) { return l.isDisplay; });
            setType(tmp);
        }
        else {
            setType(reportType_1.reportType);
        }
    }, [props.isGroup]);
    return (react_1.default.createElement(DropDown_1.default, { defaultValue: props.value, error: props.error, label: props.label, name: "report_type", onChange: function (e) {
            props.onChange(e);
        }, options: type, value: props.value }));
}
ReportType.propTypes = {
    error: prop_types_1.default.any,
    placeholder: prop_types_1.default.string,
    style: prop_types_1.default.object,
    className: prop_types_1.default.string,
    label: prop_types_1.default.any,
    value: prop_types_1.default.any,
    onChange: prop_types_1.default.any,
    isGroup: prop_types_1.default.any,
};
exports.default = ReportType;
